<template>
  <v-menu
    bottom
    origin="center center"
    transition="scale-transition"
    style="z-index: 999999"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :color="$vuetify.theme.dark ? '#131816' : '#F5F1FF'"
        depressed
        v-bind="attrs"
        v-on="on"
        min-width="140"
        height="45"
        class="pa-0 body-1 rounded-2"
        style="text-transform: unset"
      >
        <v-avatar width="30" height="30">
          <img
            :src="
              avatar
                ? getImage(avatar)
                : require('@/app/user-module/assets/images/user-placeholder.png')
            "
            @error="$event.target.src = require('@/app/user-module/assets/images/user-placeholder.png')"
          />
        </v-avatar>
        <span class="text-truncate d-inline-block">
          {{ name }}
        </span>

        <v-spacer />

        <!-- {{ data.firstName }} -->
        <v-icon class="mx-2" style="opacity: 0.5"> mdi-chevron-down </v-icon>
      </v-btn>
      <!-- <vue-feather
        type="user"
        class="secondary--text pa-2"
        v-bind="attrs"
        v-on="on"
      /> -->
    </template>

    <v-list class="text-start">
      <template v-if="isAuthenticated">
        <v-list-item v-if="canShow('Profile')" class="hand-cursor">
          <v-list-item-title @click="$router.push({ name: 'Profile' })">
            {{ $t("user.profile.myProfile") }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item v-if="canShow('ChangePassword')" class="hand-cursor">
          <v-list-item-title @click="$router.push({ name: 'ChangePassword' })">
            {{ $t("user.profile.changePassword") }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item class="hand-cursor">
          <v-list-item-title @click="signOut">
            {{ $t("user.signOut") }}
          </v-list-item-title>
        </v-list-item>
      </template>

      <template v-else>
        <v-list-item v-if="canShow('SignIn')" class="hand-cursor">
          <v-list-item-title @click="$router.push({ name: 'SignIn' })">
            {{ $t("user.signIn.login") }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { signOut } from "../methods/signOut";

export default {
  computed: {
    name() {
      return this.textAbstract({
        text: this.$store.state.authenticatedUser.firstName,
        maxLength: 20,
        delimiter: ".",
      });
    },
    avatar() {
      return this.$store.state.authenticatedUser.avatar;
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
  },
  methods: {
    canShow(routeName) {
      return routeName !== this.$route.name;
    },
    signOut() {
      const msg =
        this.$i18n.locale === "ar"
          ? "هل أنت متأكد من تسجيل الخروج؟"
          : "Are you sure to sign out?";

      this.$dialog
        .confirm(msg)
        .then(() => signOut())
        .catch(_ => {});
    },
  },
};
</script>

<style lang="scss" scoped />
